import { Base } from '@studiometa/js-toolkit';
import { gsap } from 'gsap';

/**
 *
 */
export default class Single extends Base {
  static config = {
    name: 'Single',
    refs: ['hero', 'items[]', 'intro'],
  };

  /**
   *
   */
  mounted() {
    if (window.__pageTransitioning) {
      document.addEventListener('page:enter', () => this.intro(), { once: true });
    } else if (window.__loaderComplete) {
      this.intro();
    } else {
      document.addEventListener('loader:complete', () => this.intro(), { once: true });
    }
  }

  /**
   * Play the intro animation.
   */
  intro() {
    const tl = gsap.timeline();

    tl.fromTo(
      this.$refs.hero,
      { opacity: 0, scale: 1.1 },
      { opacity: 1, scale: 1, duration: 1.4, ease: 'power4.out' },
    );

    tl.fromTo(
      this.$refs.intro,
      { clipPath: 'inset(0% 0% 100% 0%)', opacity: 1 },
      { clipPath: 'inset(0% 0% 0% 0%)', duration: 0.8, ease: 'power3.out' },
      '<',
    );

    tl.fromTo(
      this.$refs.items,
      { opacity: 0, y: 20 },
      { opacity: 1, y: 0, duration: 0.8, ease: 'power2.out', stagger: 0.15 },
      '-=0.6',
    );
  }
}
